export const listCheck = (list: any, flag: any) => {
  return list.map((ele: any) => {
    return {
      ...ele,
      isSelected: flag,
    };
  });
};
